import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import {
  convertToDecimals,
  fallbackText,
  IPharmacyShiftRating,
} from '@pharmaplan/common';

import strings from '../../../../localization';

import styles from './styles';
import WithSkeleton from '../../../common/WithSkeleton';

interface IPharmacyRatingLink {
  rating: IPharmacyShiftRating;
  successAction: string;
}

const PharmacyRatingLink: FC<IPharmacyRatingLink> = ({
  rating,
  successAction,
}) => {
  const {
    totalBookings = 0,
    canceledPercent = 0,
    averageResponseTime,
    cancellations = 0,
  } = rating ?? {};

  const SkeletonBox = WithSkeleton({
    successAction,
    variant: 'text',
  })(Box);

  return (
    <>
      <SkeletonBox sx={styles.labelContainer}>
        <Typography sx={[styles.label, styles.flexMax]}>
          {strings.noOfContract}
        </Typography>
        <Typography sx={[styles.label, styles.bold, styles.flexMax]}>
          {totalBookings}
        </Typography>
      </SkeletonBox>

      <SkeletonBox sx={styles.labelContainer}>
        <Typography sx={[styles.label, styles.flexMax]}>
          {strings.cancellations}
        </Typography>
        <Typography
          sx={[styles.label, styles.bold, styles.flexMax, styles.wrapText]}
        >
          {`${cancellations} (${
            convertToDecimals(canceledPercent) ?? fallbackText
          }% ${strings.formatString(strings.basedOnNBookings, totalBookings)})`}
        </Typography>
      </SkeletonBox>

      <SkeletonBox sx={styles.labelContainer}>
        <Typography sx={[styles.label, styles.flexMax]}>
          {strings.averageResponseTime}
        </Typography>
        <Typography sx={[styles.label, styles.bold, styles.flexMax]}>
          {averageResponseTime
            ? `${convertToDecimals(averageResponseTime)}${
              strings.hoursAbbreviation
            }`
            : fallbackText}
        </Typography>
      </SkeletonBox>
    </>
  );
};

export default PharmacyRatingLink;
